import React from 'react';
import PropTypes from 'prop-types';
import { ApexSubmit as ApexSubmit$1 } from '@zillow/zrs-cms';

var BlockApexSubmit = function BlockApexSubmit(_ref) {
  var attrs = _ref.attrs;
  return /*#__PURE__*/React.createElement(ApexSubmit$1, attrs, attrs.content);
};
BlockApexSubmit.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
} : {};
var ApexSubmit = BlockApexSubmit;

export { ApexSubmit as default };
